import { CROSS_MARKET_EMAIL_DYNAMIC_FIELDS } from '@rd-web-markets/shared/dist/util/constants';
import './util/selectedRowDimmed.css';
export const USER_PAGE_AVAILABLE_FOR_ACCOUNT_TYPES = ['super_consultant', 'admin'];
export const CONSULTANT_ROLE_NAME = 'super_consultant';
export const USER_ACCOUNT_TYPES = ['customer', CONSULTANT_ROLE_NAME, 'admin'];
const adminTab = {
  eventKey: 'admin',
  title: 'admins'
};
const consultantTab = {
  eventKey: 'super_consultant',
  title: 'consultants'
};
const customerTab = {
  eventKey: 'customer',
  title: 'customers'
};
export const USER_TABS = {
  admin: [customerTab, consultantTab, adminTab],
  super_consultant: [customerTab]
};
export const USER_ACCOUNT_TYPES_DISPLAY_NAME = {
  'customer': 'customer',
  [CONSULTANT_ROLE_NAME]: 'consultant',
  'admin': 'admin'
};
export const UTR_TEXT = 'UTR';

/** Elster financial year version cutoff: start dates before this suggest version_7, on or after suggest version_8 */
export const ELSTER_VERSION_7_CUTOFF = new Date(2024, 0, 1); // 01/01/2024
export const SPRINT_CLAIM_NAME = 'DE_Sprint_Claim';
export const TEMPLATE_PAGE_TITLE = 'Claim Template Listing';
export const CLAIM_GROUP_ENGAGEMENT_TITLE = 'contacts_email_kick_off_meeting_organization';
export const COMPANY_REQUIRES_COMPANIES_HOUSE_INFO = false;
export const CLAIM_SELECTION_ALLOWS_SLICING_MULTI_YEAR_CLAIMS = false;
export const PROJECT_GROUP_RPOGRAM_TYPE_NAME = 'program_commercial_project';
export const EDITOR_CLAIM_SPECIFIC_DYNAMIC_FIELDS = [{
  field: 'accounting_period_end_date',
  title: 'Accounting Period End Date',
  editableInModal: true
}, {
  field: 'accounting_period_start_date',
  title: 'Accounting Period Start Date',
  editableInModal: true
}, {
  field: 'total_qualifying_rnd_expenditure',
  title: 'Total Qualifying RND Expenditure'
}];
export const EDITOR_CLAIM_GROUP_DYNAMIC_FIELDS = [{
  field: 'executive_summary',
  title: 'Executive Summary'
}, {
  field: 'general_rnd_process',
  title: 'General R&D Process'
}, {
  field: 'elimination_of_uncertainty_requirement',
  title: 'Elimination of uncertainty requirement'
}, {
  field: 'process_of_experimentation_requirement',
  title: 'Process of experimentation requirement'
}, {
  field: 'technological_in_nature_requirement',
  title: 'Technological in nature requirement'
}, {
  field: 'contact_to_collaborate_on_rnd',
  title: 'Contact To Collaborate',
  editableInModal: true
}];
export const EDITOR_CLAIM_PROJECT_FIELDS = [];
export const NEW_COMPANY_NEEDS_COMPANY_NUMBER = false;
export const CLAIM_GROUP_DEFAULT_PARAMS = {
  consultants_attributes: [],
  project_methodology: 'employee_basis',
  rnd_collaborate_contacts_attributes: [],
  has_overdue_taxes: false,
  has_staff_involved_not_on_payroll: false,
  accounts_provided: false,
  tax_computations_provided: false,
  development_costs_capitalised: false,
  contracted_by_third_party: false,
  received_grants_or_subsidies: false,
  reimburses_staff_expenses: false,
  purchased_company_cars: false,
  has_patents: false
};
export const CLAIM_GROUP_EDIT_FORM_FIELDS = {
  showSicCodesString: false,
  showProjectMehotdology: false,
  showOverdueTaxesSection: false,
  showOverdueTaxesQuestion: true,
  showDoesCompanyReimburseStaffExpenses: true,
  showDoesCompanyPayCarAllowance: true,
  showClassificationForRndTaxPurposes: false
};
export const SHOULD_SHOW_COST_METHODOLOGY = false;
export const SHOULD_SHOW_OVERDUE_TAXES = false;
export const CLIENT_CONTACT_TYPES = ['Financial Contact', 'Client Sponsor', 'Contact - Elster Zertifikat', 'Contractor'];
export const EXTERNAL_CONTACT_TYPES = ['Auditor'];
export const CLAIM_GROUP_EDIT_PAGE_SHOW_YEAR_END_DROPDOWN = false;
export const CLAIM_GROUP_SHOW_ALL_PROJECT = true;
export const APP_FOOTER_TEXT = 'R&D Tax Credits Portal by Ayming';
export const APP_RELEASE_VERSION = 'Release 1.140.1';
export const LOCALE = 'de-DE';
export const ENGINE_NAME = 'DeSection';
export const EMAIL_TEMPLATE_DYNAMIC_FIELDS = {
  email_template: CROSS_MARKET_EMAIL_DYNAMIC_FIELDS,
  client_cost_template: CROSS_MARKET_EMAIL_DYNAMIC_FIELDS,
  claim_schedule_ics_event_template: CROSS_MARKET_EMAIL_DYNAMIC_FIELDS,
  self_declaration_template: CROSS_MARKET_EMAIL_DYNAMIC_FIELDS
};
export const SHOW_CLAIM_GROUP_TASKS = false;
export const SHOW_COMPANY_CLAIM_GROUP_EDIT_FORM_FIELDS = true;
export const MARKET_SPECIFIC_RD_OR_4 = 'R&D';
export const MARKET_SPECIFIC_RD_OR_4_MENU = 'R&D Technical';
export const TEMPLATE_HEADER_TITLE = {
  email_template: 'Configure Kick Off Template',
  client_cost_template: 'Configure Client Cost Template',
  claim_schedule_ics_event_template: 'Configure Ics Event Template',
  self_declaration_template: 'Configure Self - Declaration Email Template',
  kick_off: 'Configure Kick Off Template'
};
export const REPORT_SAVE_PARAM = '';
export const LOCAL_LANGUAGES = ['de', 'en'];
export const REPORT_TYPE_INCLUDE_SECTION_COLUMN_NAME = {
  technical: 'include_in_technical_report'
};
export const TASK_TITLE = 'claim_group_tasks';
export const CURRENCY_SYMBOL = '€';
export const SIDEBAR_MENU_ITEMS = [{
  text: 'edit_company_info',
  link: 'de/edit_company_info'
}, {
  text: 'mission_information',
  isOpen: true,
  subMenu: [{
    text: 'edit_claim_info',
    link: 'edit/general'
  }, {
    text: 'engagement_team',
    link: 'engagement_team'
  }, {
    text: 'contract',
    link: 'company_contracts'
  }, {
    text: 'undertaking_in_difficulty',
    link: 'undertaking_in_difficulty'
  }]
}];
export const SIDEBAR_MENU_ITEMS_MANAGER = [{
  text: 'edit_claim_info',
  link: 'edit/general'
}, {
  text: 'engagement_team',
  link: 'engagement_team'
}];
export const SIDEBAR_MENU_ITEMS_CONSULTANT = [{
  text: 'edit_claim_info',
  link: 'edit/general'
}, {
  text: 'engagement_team',
  link: 'engagement_team'
}];
export const SIDEBAR_NAV_ADMIN_LINKS = [{
  text: 'companies',
  link: 'companies'
}, {
  text: 'claim_groups',
  link: 'claims',
  subMenu: [{
    text: 'my_claim_groups',
    link: 'my_claim_groups'
  }, {
    text: 'all_claim_groups',
    link: 'all_claim_groups'
  }]
}, {
  text: 'users',
  link: 'users'
}, {
  text: 'templates',
  link: 'templates',
  subMenu: [{
    text: 'project_progress_template',
    link: 'claim_template'
  }, {
    text: 'kick_off_email_template',
    link: 'kickoff_email_template'
  }, {
    text: 'cliam_schedule_ics_event_template',
    link: 'claim_schedule_ics_event_template'
  }, {
    text: 'client_cost_template',
    link: 'client_cost_template'
  }, {
    text: 'faq',
    link: 'faq_template'
  }]
}, {
  text: 'translations',
  link: 'translations'
}];
export const SIDEBAR_NAV_MANAGER_LINKS = [{
  text: 'companies',
  link: 'companies'
}, {
  text: 'claim_groups',
  link: 'claims',
  subMenu: [{
    text: 'my_claim_groups',
    link: 'my_claim_groups'
  }, {
    text: 'all_claim_groups',
    link: 'all_claim_groups'
  }]
}, {
  text: 'users',
  link: 'users'
}, {
  text: 'templates',
  link: 'templates',
  subMenu: [{
    text: 'project_progress_template',
    link: 'claim_template'
  }, {
    text: 'rd_report_template',
    link: 'report_templates'
  }, {
    text: 'kick_off_email_template',
    link: 'kickoff_email_template'
  }, {
    text: 'cliam_schedule_ics_event_template',
    link: 'claim_schedule_ics_event_template'
  }, {
    text: 'client_cost_template',
    link: 'client_cost_template'
  }, {
    text: 'faq',
    link: 'faq_template'
  }]
}, {
  text: 'translations',
  link: 'translations'
}];
export const SIDEBAR_NAV_CLIENT_LINKS = [{
  text: 'All Claims',
  link: ''
}];
export const SIDEBAR_NAV_ACCOUNTANT_LINKS = [{
  text: 'All Claims',
  link: ''
}];
export const SIDEBAR_NAV_CONSULTANT_LINKS = [{
  text: 'companies',
  link: 'companies'
}, {
  text: 'Claims',
  link: 'my_claim_groups'
}];
export const SIDEBAR_NAV_SUPER_CONSULTANT_LINKS = [{
  text: 'Companies',
  link: 'companies'
}, {
  text: 'claim_groups',
  link: 'claims',
  subMenu: [{
    text: 'my_claim_groups',
    link: 'my_claim_groups'
  }, {
    text: 'all_claim_groups',
    link: 'all_claim_groups'
  }]
}, {
  text: 'users',
  link: 'users'
}];
export const SIDEBAR_CLAIM_COSTS_LINKS = [{
  text: 'Upload/Download Cost Template',
  link: 'financial_details/upload'
}, {
  text: 'Cost Categories',
  link: 'financial_details/general'
}, {
  text: 'Client Cost Email',
  link: 'financial_details/email'
}, {
  text: 'Edit Claim',
  link: 'edit/general'
}, {
  text: 'Manager Cost Review',
  link: 'financial_details/manager_review'
}];
export const SIDEBAR_CLAIM_COSTS_LINKS_CUSTOMER = [{
  text: 'Upload/Download Cost Template',
  link: 'financial_details/upload'
}, {
  text: 'Cost Categories',
  link: 'financial_details/general'
}];
export const SIDEBAR_CLAIM_COSTS_LINKS_ACCOUNTANT = [{
  text: 'Cost Categories',
  link: 'financial_details/general'
}];
export const SIDEBAR_CLAIM_OVERVIEW_LINKS_CUSTOMER = [{
  text: 'Claim Cost',
  link: 'claim_cost',
  subMenu: true
}, {
  text: 'R&D Technical',
  link: 'technical_section'
}];
export const SIDEBAR_NAV_RND_REPORT_PAGE_CLIENT_LINKS = {
  link: 'companies',
  text: 'Companies'
};
export const ADMIN_COMMON_ACTIONS = [{
  text: 'add_company_action',
  link: 'companies/new'
}, {
  text: 'add_user_action',
  link: 'users/new'
}];
export const CONSULTANT_COMMON_ACTIONS = [{
  text: 'add_company_action',
  link: 'companies/new'
}];
export const CURRENCY_FORMATTER = new Intl.NumberFormat(LOCALE);
export const PERCENTAGE_FORMATTER = new Intl.NumberFormat(LOCALE, {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
});
export const ENGAGEMENT_TEAM_ROLES = [{
  value: 'client_sponsor'
}, {
  value: 'financial_contact'
}, {
  value: 'contact_elster_zertifikat'
}, {
  value: 'contractor'
}, {
  value: 'project_manager'
}, {
  value: 'project_member'
}];
export const CLIENT_RND_EDIT_DYNAMIC_FIELD = true;
export const CLIENT_RND_SELECT_PROJECT_POPOVER = true;
export const SUPPORT_EMAIL_ADDRESS = 'de.support.advance@ayming.com';
export const ATTACHMENT_OPTIONS = {
  attachCostTemplate: false,
  technicalTemplateField: false,
  includeTechnicalUploadField: false,
  includeCostTemplateLink: false
};
export const TEMPLATE_SELECT_MODEL_NAME = 'REPLACE_IF_NEEDED'; //so the build would not fail other wise not needed yet
export const PROJECT_FIELD_MODEL_NAME = 'REPLACE_IF_NEEDED'; //so the build would not fail other wise not needed yet
export const SHOULD_CREATE_REPORT = false; //so the build would not fail other wise not needed yet

export const modifyReportTemplateCategoriesForProject = [0, 0]; //at index 0, remove no element

export const SHOW_DEPARTMENT_FOR_USER_FORM = true;
export const SHOULD_PROJECT_POPOVER_EXCLUDE_OTHER_PROJECTS = false;
export const TINYMCE_MARKET_REPORT_MODULES = ['styles_formatter', 'track_changes', 'comments', 'resize_image_when_added'];
export const TINYMCE_MARKET_EMAIL_MODULES = ['styles_formatter', 'resize_image_when_added'];
export const TINYMCE_MARKET_OTHER_MODULES = ['styles_formatter', 'track_changes', 'comments', 'resize_image_when_added'];
export const SIDEBAR_TECHNICAL_SECTION_LINKS = []; // needed for build
export const SHOW_COST_MENU_IN_MASTER = true;
export const SHOW_DOWNLOAD_TEMPLATE_BUTTON = true;
export const SHOW_SIDE_BAR_IN_CLAIM_GROUP_OVERVIEW = false;
export const FINANCIAL_SECTION_GENERAL_LINK = 'general';
export const SHOULD_AUTOSAVE = false;
export const SHOULD_PRESET_COMPANY_CLAIMGROUP_FORM_FILEDS = false;
export const SHOULD_SHOW_ADD_USER_BUTTON_FOR_ADMINS = false;
export const SHOULD_SHOW_ADMIN_OPTION_FOR_CONSULTANTS = true;
export const IS_PROJECT_DATE_SHORT_FORMAT = false;
export const DATES_BASED_ON_CURRENT_YEAR = true;
export const SHOULD_SHOW_DATE_IN_SUMMARY_SECTION = false;
export const RATES_SCHEME = {
  'Enhancement Rates': ['rate'],
  'Credit Rates': ['rate'],
  'Corporation Tax Rates': ['rate'],
  'NI Rates': ['rate'],
  'NI Thresholds': ['threshold']
};
export const SHOULD_ADD_REPORT_TEMPLATE_SEARCH = false;
export const SHOULD_SHOW_TEMPLATE_TITLE = false;
export const SHOW_SEND_CLAIM_BUTTON = false;
export const PROJECT_REPORT_DATE_PICKER_TYPE = 'date';
export const SHOW_CLAIM_GROUP_PROJECT_ELSTER = true;
export const SHOW_PROJECT_TEMPLATE_SELECT = false;
export const SHOW_KICK_OFF_DATES = true;
export const SHOW_IT_TYPE_SELECT = false;
export const SHOW_PROJECT_GROUPING_TAB_ON_PROJECT_OVERVIEW_PAGE = false;
export const SHOW_MARKET_PROGRAM_LIST = false;
export const PROJECT_OVERVIEW_TABLE = {
  headers: [{
    text: 'name',
    sortable: true,
    orderBy: 'project_name',
    filterableByText: true,
    filterBy: 'project_name',
    width: '200px'
  }, {
    text: 'project_status',
    sortable: true,
    orderBy: 'completion_status',
    hideSortIcon: true,
    filterableBySelect: true,
    filterBy: 'project_status',
    filterOptions: ['completion_status_unstarted', 'completion_status_in_progress', 'completion_status_finished'],
    width: '150px'
  }, {
    text: 'rd_start_date',
    sortable: true,
    orderBy: 'start_date',
    filterableByDate: true,
    filterBy: 'start_date',
    width: '160px'
  }, {
    text: 'rd_end_date',
    sortable: true,
    orderBy: 'end_date',
    filterableByDate: true,
    filterBy: 'end_date',
    width: '160px'
  }, {
    text: 'year',
    sortable: true,
    orderBy: 'rd_start_year',
    filterableBySelect: true,
    filterBy: 'rd_start_year',
    filterOptions: [],
    width: '140px'
  }, {
    text: 'milestone',
    sortable: true,
    orderBy: 'milestone',
    filterableBySelect: true,
    filterBy: 'milestone',
    filterOptions: ['milestone_ffc_blocked', 'milestone_bsfz_reply', 'milestone_bsfz_submitted', 'milestone_ffc_passed', 'milestone_started', 'milestone_created'],
    width: '200px'
  }, {
    text: 'bsfz_response',
    sortable: true,
    orderBy: 'current_bsfz_response_date',
    filterableByDate: true,
    filterBy: 'current_bsfz_response_date',
    width: '250px'
  }, {
    text: 'deadline',
    sortable: true,
    orderBy: 'current_deadline_date',
    filterableByDate: true,
    filterBy: 'current_deadline_date',
    width: '140px'
  }],
  columns: ['project_name', 'completion_status_show_only', 'start_date', 'end_date', 'rd_start_year', 'milestone', 'current_bsfz_response_date', 'current_deadline_date', 'deleteButton']
};
export const PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR = false;

// Implemented in the UK, dummy value here
export const PROJECT_OVERVIEW_TABLE_EMPTY_COLUMN_SELECTOR_JSON = {};
// Implemented in the UK, dummy value here
export const PROJECT_OVERVIEW_TABLE_MINIMUM_REQUIRED_COLUMNS = [];
export const PROJECT_OVERVIEW_HEADER_ELEMENT_STYLES = {
  TOP_ELEMENT: {
    marginBottom: '10px'
  },
  LOWER_ELEMENT: {
    paddingBottom: '10px'
  }
};
export const PROJECT_EXPORT_FIELDS_LIST = ['entity', 'commercial_project_name', 'business_unit', 'project_name', 'project_code', 'project_start_date', 'project_end_date', 'project_rnd_start_date', 'project_rnd_end_date', 'project_type', 'category', 'assessment', 'completion_status', 'commercial_project_code', 'commercial_project_type', 'include_in_rnd_report', 'rnd_project_baseline', 'rnd_project_advance', 'rnd_project_uncertainty', 'rnd_project_work_done', 'rnd_project_additional_comments', 'technical_narrative_current_state_of_knowledge', 'technical_narrative_capabilities', 'technical_narrative_technical_uncertainties', 'technical_narrative_uncertainties_overcome', 'technical_narrative_conclusion', 'competent_professional_name', 'competent_professional_qualifications', 'competent_professional_relevant_experience', 'competent_professional_email', 'competent_professional_phone', 'competent_professional_exclude_from_rnd_report', 'competent_professional_comments', 'comments'];
export const COST_EXPORT_FIELDS_LIST = [];
export const SHOW_QUESTIONNAIRES_SELECT_SEPARATELY = false;
export const SHOW_REGULAR_REALTIME_DASHBOARD = false;
export const SHOW_ADD_CLAIM_GROUP_BTN_ON_MASTER_PAGE = false;
export const SHOULD_SHOW_ADD_CLAIM_BUTTON_IN_CLAIM_GROUP_SIDEBAR = true;
export const SHOULD_SHOW_ADD_COMPANY_BUTTON = true;
export const SHOULD_SHOW_ADD_USERS_TO_COMPANY = false;
export const ADD_NEW_USER_TO_COMPANY = false;
export const ACCOUNT_TYPES_THAT_CAN_ADD_USER_TO_COMPANY = ['customer', 'accountant'];
export const SHOULD_SHOW_CREATE_PROJECTS_PAGE_FOR_CUSTOMER = false;
export const SHOW_EDIT_BUTTON_FOR_RESTRICTED_FOLDER = true;
export const FILE_MANAGEMENT_COLUMN_ORDER = ['folderIcon', 'createdAt', 'name', 'notes', 'uploadedBy', 'editButton'];
export const PROJECT_OVERVIEW_ALL_CONTACTS_MAX_AMOUNT_OF_PROJECT_BADGES = Number.MAX_VALUE;
export const DASHBOARD_PAGE_SIDE_BAR_MENU_ITEMS = {
  link: 'dashboards',
  text: 'Dashboards'
};
export const SIDEBAR_MENU_ITEMS_CUSTOMER = [{
  text: 'project_overview',
  link: 'project_overview'
}, {
  text: 'engagement_team',
  link: 'engagement_team'
}];
export const SHOW_COMPANY_GROUPS_HEADER = true;
export const SHOW_ADD_PROJECTS_BUTTON_ON_MASTER_PAGE = true;
export const SHOW_IMPORT_PROJECT_AT_PROJECT_OVERVIEW = false;
export const SHOW_ADD_PROJECT_AT_PROJECT_OVERVIEW = true;
export const SHOW_SEND_QUESTIONNAIRE_BUTTON_ON_PROJECT_OVERVIEW_PAGE = false;
export const SHOW_PROJECT_QUESTIONNAIRE_BUTTON_ON_PROJECT_OVERVIEW_PAGE = false;
export const SHOW_QUESTIONNAIRES_TAB_IN_PROJECT_OVERVIEW = false;
export const SHOW_FAQ_ENTRY_HEADER = true;
export const SHOW_CLAIM_GROUPS_SELECTOR = true;
export const UPLOAD_COST_TEMPLATE_PAGE_TITLE = 'Upload Cost Template';
export const UPLOAD_COST_TEMPLATE_BUTTON_NAME = 'Upload Cost Template';
export const DOWNLOAD_COST_TEMPLATE_BUTTON_NAME = 'Download Template';
export const FINANCIAL_DATA_PAGE_NAME = 'Cost Categories';
export const SHOW_CLAIM_DELETE_BUTTON = false;
export const SHOW_ADD_FINANCIAL_YEAR = true;
export const SHOW_BATCH_PROJECT_LOAD_BTN = false;
export const SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION = false;
export const CONSULTANT_COMMON_ACTIONS_NO_DASHBOARD = [{
  text: 'view_documents',
  link: 'documents'
}];
export const SHOULD_CALL_COMPANY_MENU = true;
export const SHOULD_CREATE_NOT_FOUND_SEARCHED_COMPANY = true;
export const USERS_TYPE_WHO_CAN_INVITE_NEW_USERS = [];
export const SHOW_ALERT_POPUP_FOR_DELETE_DOCUMENT_ATTACHMENT_COMPONENT = true;
export const SHOW_CLAIM_GROUP_NAME_ON_MASTER_PAGE = false;
export const SHOW_ADD_PROJECT_LEFT = true;
export const USER_PAGE_CUSTOMER_DISPLAY_FIELDS = {
  admin: ['name', 'role', 'contact', 'is_active'],
  consultant: ['name', 'role', 'is_active'],
  manager: ['name', 'role', 'is_active'],
  super_consultant: ['name', 'role', 'contact'],
  customer: []
};
export const COMPANY_BUTTONS_FORM_BOOTSTRAP_CLASS = 'justify-content-between';
export const COMPANY_PAGE_PAGINATION_CLASS = 'justify-content-center mt-3';
export const UNSAVED_CHANGES_MESSAGE = 'you_have_unsaved_changes_are_you_sure_you_want_to_leave';
export const SHOW_PROJECT_OVERVIEW_COST_SUMMARY_ROW = false;
export const FEDERAL_STATE_OPTIONS = [{
  value: 'baden_wuerttemberg',
  label: 'Baden-Wuerttemberg',
  code: 'bw',
  germanName: 'baden-württemberg'
}, {
  value: 'bayern',
  label: 'Bayern',
  code: 'by',
  germanName: 'bayern'
}, {
  value: 'berlin',
  label: 'Berlin',
  code: 'be',
  germanName: 'berlin'
}, {
  value: 'brandenburg',
  label: 'Brandenburg',
  code: 'bb',
  germanName: 'brandenburg'
}, {
  value: 'bremen',
  label: 'Bremen',
  code: 'hb',
  germanName: 'bremen'
}, {
  value: 'hamburg',
  label: 'Hamburg',
  code: 'hh',
  germanName: 'hamburg'
}, {
  value: 'hesse',
  label: 'Hesse',
  code: 'he',
  germanName: 'hessen'
}, {
  value: 'mecklenburg_vorpommern',
  label: 'Mecklenburg-Vorpommern',
  code: 'mv',
  germanName: 'mecklenburg-vorpommern'
}, {
  value: 'lower_saxony',
  label: 'Lower Saxony',
  code: 'ni',
  germanName: 'niedersachsen'
}, {
  value: 'north_rhine_westphalia',
  label: 'North Rhine-Westphalia',
  code: 'nw',
  germanName: 'nordrhein-westfalen'
}, {
  value: 'rheinland_pfalz',
  label: 'Rheinland-Pfalz',
  code: 'rp',
  germanName: 'rheinland-pfalz'
}, {
  value: 'saarland',
  label: 'Saarland',
  code: 'sl',
  germanName: 'saarland'
}, {
  value: 'saxony',
  label: 'Saxony',
  code: 'sn',
  germanName: 'sachsen'
}, {
  value: 'saxony_anhalt',
  label: 'Saxony-Anhalt',
  code: 'st',
  germanName: 'sachsen-anhalt'
}, {
  value: 'schleswig_holstein',
  label: 'Schleswig-Holstein',
  code: 'sh',
  germanName: 'schleswig-holstein'
}, {
  value: 'thuringia',
  label: 'Thuringia',
  code: 'th',
  germanName: 'thüringen'
}];
export const LEGAL_FORM_OPTIONS = [{
  value: 'non_selected',
  translationKey: null
}, {
  value: 'aktiengesellschaft',
  translationKey: 'aktiengesellschaft'
}, {
  value: 'aktiengesellschaft_kg',
  translationKey: 'aktiengesellschaft_kg'
}, {
  value: 'aktiengesellschaft_ohg',
  translationKey: 'aktiengesellschaft_ohg'
}, {
  value: 'kapitalgesellschaft',
  translationKey: 'kapitalgesellschaft'
}, {
  value: 'personengesellschaft',
  translationKey: 'personengesellschaft'
}, {
  value: 'eingetragene_gennosenchaft',
  translationKey: 'eingetragene_gennosenchaft'
}, {
  value: 'eingetragener_verein',
  translationKey: 'eingetragener_verein'
}, {
  value: 'einzelunternehmer',
  translationKey: 'einzelunternehmer'
}, {
  value: 'juristische_person',
  translationKey: 'juristische_person'
}, {
  value: 'europäische_gesellschaft',
  translationKey: 'europäische_gesellschaft'
}, {
  value: 'europäische_wirtschaftliche',
  translationKey: 'europäische_wirtschaftliche'
}, {
  value: 'gesellschaft_haftung',
  translationKey: 'gesellschaft_haftung'
}, {
  value: 'gesellschaft_haftung_kg',
  translationKey: 'gesellschaft_haftung_kg'
}, {
  value: 'gesellschaft_haftung_ohg',
  translationKey: 'gesellschaft_haftung_ohg'
}, {
  value: 'gbr',
  translationKey: 'gbr'
}, {
  value: 'kommanditgesellschaft',
  translationKey: 'kommanditgesellschaft'
}, {
  value: 'kommanditgesellschaft_afu_aktien',
  translationKey: 'kommanditgesellschaft_afu_aktien'
}, {
  value: 'ohg',
  translationKey: 'ohg'
}, {
  value: 'partnerschaft',
  translationKey: 'partnerschaft'
}, {
  value: 'sonstige_ausländische_rechtsform',
  translationKey: 'sonstige_ausländische_rechtsform'
}, {
  value: 'sonstige_personengesellschaft',
  translationKey: 'sonstige_personengesellschaft'
}];
export const DELETE_FILE_CONFIRMATION_MESSAGE = 'confirm_delete_file';
export const DELETE_CONFIRMATION_MESSAGE = 'confirm_delete';

/** CSS class for dimming a selected row in list/detail UIs (e.g. brightness 85%). */
export const SELECTED_ROW_DIMMED_CLASS = 'selected-row-dimmed';

/** Half-year dropdown options per elster staff cost year. Used by HalfYearDropdown (NameList & StaffCosts). */
export const HALF_YEAR_OPTIONS_BY_ELSTER_YEAR = {
  2020: [{
    key: 'not_selected',
    value: 'not_selected',
    text: ''
  }, {
    key: 'before_01_07_2020',
    value: 'before_01_07_2020',
    text: 'before_01_07_2020'
  }, {
    key: 'after_30_06_2020',
    value: 'after_30_06_2020',
    text: 'after_30_06_2020'
  }],
  2024: [{
    key: 'not_selected',
    value: 'not_selected',
    text: ''
  }, {
    key: 'before_28_03_2024',
    value: 'before_28_03_2024',
    text: 'before_28_03_2024'
  }, {
    key: 'after_27_03_2024',
    value: 'after_27_03_2024',
    text: 'after_27_03_2024'
  }]
};
export const TECHNICAL_UPLOAD_SUBMIT_BUTTON_TYPE = 'save';
export const DELETE_BUTTON_TYPE = 'square';
export const ADD_BUTTON_TYPE = 'standard';
export const SHOW_NOTIFY_CLAIM_USERS_MODAL = false;
export const ADD_USER_BUTTON_TEXT = 'add_contact_details';
export const ADD_CONTACT_BUTTON_TEXT = 'assign_contact';
export const USE_V2_DESIGN = false;